"use client"

import { useEffect, useState, useRef } from "react"

declare global {
    interface Window {
        google: any
        googleTranslateElementInit: any
    }
}

export function GoogleTranslator() {
    const [isScriptLoaded, setIsScriptLoaded] = useState(false)
    const hasLoadedRef = useRef(false)

    useEffect(() => {
        const loadGoogleTranslate = () => {
            if (hasLoadedRef.current) return
            hasLoadedRef.current = true

            // Initialize function
            window.googleTranslateElementInit = () => {
                new window.google.translate.TranslateElement(
                    {
                        pageLanguage: "en",
                        autoDisplay: false,
                        includedLanguages: "en,hi,bn,te,mr,ta,gu,kn,ml,pa,or,as,ne,ur", // Add all needed languages
                        layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
                    },
                    "google_translate_element"
                )
                setIsScriptLoaded(true)
            }

            // Add Google Translate script
            const addScript = document.createElement("script")
            addScript.setAttribute(
                "src",
                "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"
            )
            document.body.appendChild(addScript)
        }

        // Load after 3 seconds or on first interaction to save initial load penalties
        const timer = setTimeout(loadGoogleTranslate, 3000)

        const handleInteraction = () => {
            loadGoogleTranslate()
            cleanup()
        }

        const cleanup = () => {
            window.removeEventListener("scroll", handleInteraction)
            window.removeEventListener("mousemove", handleInteraction)
            window.removeEventListener("touchstart", handleInteraction)
            window.removeEventListener("keydown", handleInteraction)
        }

        window.addEventListener("scroll", handleInteraction, { passive: true })
        window.addEventListener("mousemove", handleInteraction, { passive: true })
        window.addEventListener("touchstart", handleInteraction, { passive: true })
        window.addEventListener("keydown", handleInteraction, { passive: true })

        return () => {
            clearTimeout(timer)
            cleanup()
        }
    }, [])

    return (
        <div
            id="google_translate_element"
            className="fixed bottom-0 right-0 opacity-0 pointer-events-none z-[-1]"
        />
    )
}
